//libraries
import React, { useState, useRef, useEffect } from 'react';
import { defineMessages, FormattedMessage, RawIntlProvider, injectIntl, IntlProvider, FormattedNumber } from 'react-intl';
import classNames from 'classnames';
import moment from 'moment';
import './AdditionalVehicleDetails.css';
import { Popover, Overlay } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import * as helperFunctions from 'utils/HelperFunctions';
import MomentLocaleUtils, {
    formatDate,
    parseDate,
} from '../../../../shared/utils/MomentLocaleUtils';
import { Formik } from "formik";
import * as Yup from "yup";
import FormWrapper from "components/FormWrapper";
import Spinner from "components/Spinner";
import Help from 'components/Help';
import InputCalendar from 'components/InputCalendar';
import { enUS } from 'date-fns/locale';


// #region Component
function AdditionalVehicleDetails({ userLocale,
    usStates,
    tempLicensePlate,
    tempRegistrationState,
    licensePlate,
    registrationState,
    intl,
    whoWillLicense,
    registrationExpiration,
    deliveryDate,
    tempRegistrationExpDate,
    requestStatus,
    vendorCheckingAccount,
    subTotal,
    selectedCurrency,
    onReturnClickHandler,
    onDeleteResetClick,
    onPaymentRequestedHandler,
    vendorId,
    isDeliveryDateRequired }) {


    // #region Ref
    const noRegisterDetailsSelectionShowErrorRef = useRef();
    const registerDetailsSelectionShowErrorRef = useRef();
    const deliveryDateShowErrorRef = useRef();
    const licenseDateShowErrorRef = useRef();
    const tempDateShowErrorRef = useRef();
    const paymentInformationAcceptedShowErrorRef = useRef();
    const isIE = false || !!document.documentMode;
    // #endregion


    // #region Event handlers     
    const handleSubmit = (values, { setSubmitting, resetForm }) => {

        let paymentInformation = {
            deliveryDate: values.deliveryDate != undefined ? values.deliveryDate : undefined,
            licensePlate: values.licensePlate,
            licenseDate: values.licenseDate != undefined ? values.licenseDate : undefined,
            licenseState: values.licenseState,
            tempPlate: values.tempPlate,
            tempDate: values.tempDate != undefined ? values.tempDate : undefined,
            tempState: values.tempState,
            vendorId: vendorId

        };

        onPaymentRequestedHandler(paymentInformation);
        setSubmitting(false);

    };

    // #endregion   

    // #region International message

    const messages = defineMessages({


        dealer_draft_delivery_date_description: {
            id: 'dealer_draft_delivery_date_description',
            description: 'dealer_draft_delivery_date_description',
            defaultMessage: 'Delivery date'
        },
        dealer_draft_license_plate_description: {
            id: 'dealer_draft_license_plate_description',
            description: 'dealer_draft_license_plate_description',
            defaultMessage: 'License plate#'
        },
        dealer_draft_registration_date_description: {
            id: 'dealer_draft_registration_date_description',
            description: 'dealer_draft_registration_date_description',
            defaultMessage: 'Registration expiration'
        },
        dealer_draft_Registration_state_description: {
            id: 'dealer_draft_Registration_state_description',
            description: 'dealer_draft_Registration_state_description',
            defaultMessage: 'Registration state'
        },
        dealer_draft_reg_no_selection_label: {
            id: 'dealer_draft_reg_no_selection_label',
            description: 'None of the above',
            defaultMessage: 'None of the above'
        },
        dealer_draft_reg_label: {
            id: 'dealer_draft_reg_label',
            description: 'Registration information',
            defaultMessage: 'Registration information'
        },
        dealer_draft_temp_license_label: {
            id: 'dealer_draft_temp_license_label',
            description: 'Temp license plate #',
            defaultMessage: 'Temp license plate #'
        },
        dealer_draft_temp_exp_label: {
            id: 'dealer_draft_temp_exp_label',
            description: 'Temp registration expiration',
            defaultMessage: 'Temp registration expiration'
        },
        dealer_draft_temp_state_label: {
            id: 'dealer_draft_temp_state_label',
            description: 'Temp registration state',
            defaultMessage: 'Temp registration state'
        },
        dealer_draft_initial_license_label: {
            id: 'dealer_draft_initial_license_label',
            description: 'Initial licensing issued',
            defaultMessage: 'Initial licensing issued'
        },
        dealer_draft_temp_label: {
            id: 'dealer_draft_temp_label',
            description: 'Temp Tag issued',
            defaultMessage: 'Temp Tag issued'
        },
        dealer_draft_reg_details_label: {
            id: 'dealer_draft_reg_details_label',
            description: 'Registration details',
            defaultMessage: 'Registration details'
        },
        dealer_draft_reg_details_error_label: {
            id: 'dealer_draft_reg_details_error_label',
            description: 'Please complete all fields below',
            defaultMessage: 'Please select one of the fields below'
        },
        dealer_draft_reg_details_select_label: {
            id: 'dealer_draft_reg_details_select_label',
            description: 'Select one',
            defaultMessage: 'Select one'
        },
        dealer_draft_no_selection_error_label: {
            id: 'dealer_draft_no_selection_error_label',
            description: 'dealer_draft_no_selection_error_label',
            defaultMessage: 'Our records indicate that your dealership is to complete initial licensing. Before proceeding, please contact us at delivery@holman.com or 800-257-7781 for further assistance.'
        },
        dealer_draft_delivery_date_error_label: {
            id: 'dealer_draft_delivery_date_error_label',
            description: 'Please select a date',
            defaultMessage: 'Please select a date'
        },
        dealer_draft_delivery_date_invalid_error_label: {
            id: 'dealer_draft_delivery_date_invalid_error_label',
            description: 'Please provide a past date',
            defaultMessage: 'Please provide a past date'
        },
        dealer_draft_reg_date_invalid_error_label: {
            id: 'dealer_draft_reg_date_invalid_error_label',
            description: 'Please provide a future date',
            defaultMessage: 'Please provide a future date'
        }, dealer_draft_confirm_payment: {
            id: 'dealer_draft_confirm_payment',
            description: 'dealer_draft_confirm_payment',
            defaultMessage: 'Confirm the payment will be credited to account ending in {checkingAccount}'
        },
        dealer_draft_payment_accepted_error: {
            id: 'dealer_draft_payment_accepted_error',
            description: 'dealer_draft_payment_accepted_error',
            defaultMessage: 'Please confirm payment before requesting approval.'
        }, return: {
            id: 'return',
            description: 'Return',
            defaultMessage: 'Return'
        },
        request_payment: {
            id: 'request_payment',
            description: 'request_payment',
            defaultMessage: 'Request Payment '
        },
        restore_request: {
            id: 'restore_request',
            description: 'restore_request',
            defaultMessage: 'Restore request'
        },

    });
    // #endregion   

    // #region Render
    return <div>
        <Formik
            enableReinitialize={true}
            initialValues={{
                deliveryDate: deliveryDate !== null ?
                    new Date(moment(deliveryDate)) : undefined,
                licensePlate: licensePlate != null ? licensePlate : '',
                licenseDate: registrationExpiration !== null ?
                    new Date(moment(registrationExpiration)) : undefined,
                licenseState: registrationState != null ? registrationState : '',
                tempPlate: tempLicensePlate != null ? tempLicensePlate : '',
                tempDate: tempRegistrationExpDate !== null ?
                    new Date(moment(tempRegistrationExpDate)) : undefined,
                tempState: tempRegistrationState != null ? tempRegistrationState : '',
                registrationInformationSelection: null,
                paymentAccepted: '',
                noRegisterDetailsError: null,
                deliveryDateRange: null,
                licenseDateRange: null,
                tempDateRange: null,
                deliveryDateRequired: isDeliveryDateRequired
            }}
            onSubmit={handleSubmit}
            validationSchema={Yup.object().shape({
                deliveryDate: Yup.string().when('deliveryDateRequired', ([deliveryDateRequired], schema) => {
                    if (deliveryDateRequired) {
                        return schema.required("Required").test("is-valid-date", "Invalid", function (value) {
                            let d = new Date(value);
                            return d >= new Date(moment().subtract(50, "years").endOf('D')) && d <= new Date(moment().endOf('D')) || value === null || value === undefined
                                ? true
                                : this.createError({
                                    path: 'deliveryDateRange',
                                })
                        })
                    }
                    else{
                        return schema.notRequired()
                    }
                }),
                registrationInformationSelection: Yup.string().required("Required"),
                paymentAccepted: Yup.string().required("Required"),
                licensePlate: Yup.string().when('registrationInformationSelection', {
                    is: 'I',
                    then: (schema) => schema.required("Required") 
                }),
                licenseDate: Yup.string().when('registrationInformationSelection', {
                    is: 'I',
                    then: (schema) => 
                        schema.required("Required").test("is-valid-date", "Invalid", function (value) {
                        let d = new Date(value);
                        return d < new Date(moment().endOf('D')) && moment(value).isValid()
                            ? this.createError({
                                path: 'licenseDateRange',
                            })
                            : true
                    }).nullable()
                }),
                licenseState: Yup.string().when('registrationInformationSelection', {
                    is: 'I',
                    then: (schema) => schema.required("Required")
                }),
                tempPlate: Yup.string().when('registrationInformationSelection', {
                    is: 'T',
                    then: (schema) => schema.required("Required")
                }),
                tempDate: Yup.string().when('registrationInformationSelection', {
                    is: 'T',
                    then: (schema) =>
                        schema.required("Required").test("is-valid-date", "Invalid", function (value) {
                        let d = new Date(value);
                        return d < new Date(moment().endOf('D')) && moment(value).isValid()
                            ? this.createError({
                                path: 'tempDateRange',
                            })
                            : true
                    }).nullable()
                }),
                tempState: Yup.string().when('registrationInformationSelection', {
                    is: 'T',
                    then: (schema) => schema.required("Required")
                }),
                noRegisterDetailsError: Yup.string().when('registrationInformationSelection', {
                    is: (registrationInformationSelection) => registrationInformationSelection === 'N' && whoWillLicense === "DL",
                    then: (schema) => schema.required("Required")
                }).nullable()


            })}
        >
            {({
                values,
                touched,
                errors,
                handleSubmit,
                setFieldValue,
                isSubmitting,
            }) => {
                return (
                    <form id='my-form' onSubmit={handleSubmit}>

                        <FormWrapper />
                        <div className="additional-Vehicle_Details">
                            <div className="additional-Vehicle-Details__caption">
                                <FormattedMessage {...messages.dealer_draft_reg_label} />
                                <Help videoId="registration_information" whiteSpaceAtBottomHeight="0.7em" />
                            </div>
                            {isDeliveryDateRequired ?
                                <div className='row'>
                                    <div className="col-md-12 additional-Vehicle_Details__description" style={{ display: "inline-flex", alignItems: "center" }}>
                                        <div className="col-md-2 additional-Vehicle_Details__label">
                                            <FormattedMessage {...messages.dealer_draft_delivery_date_description} />
                                        </div>

                                        <div className={classNames('col-md-6', 'additional-Vehicle_Details__date_edit')}>
                                            <div className='row'>
                                                <div className="col-md-12">
                                                    <div className='row'>
                                                        <Overlay
                                                            show={errors.deliveryDateRange && touched.deliveryDateRange}
                                                            target={deliveryDateShowErrorRef.current}
                                                            placement="right"

                                                        >
                                                            <Popover id="popOverDeliveryDate" className="additional-Vehicle_Details__error_message">
                                                                <RawIntlProvider value={intl}>
                                                                    <FormattedMessage {...messages.dealer_draft_delivery_date_invalid_error_label} />
                                                                </RawIntlProvider>
                                                            </Popover>
                                                        </Overlay>
                                                        <div className='additional-Vehicle_Details__date_picker' ref={deliveryDateShowErrorRef}>
                                                            <InputCalendar
                                                                id="deliveryDate"
                                                                error={errors.deliveryDate}
                                                                locale={userLocale}
                                                                modifiers={{disabled: {
                                                                        before: new Date(moment().subtract(50, "years")),
                                                                        after: new Date(moment()),
                                                                }}}
                                                                initialValue={values.deliveryDate}
                                                                onDateChange={(newDate) => {
                                                                    setFieldValue(
                                                                        "deliveryDate",
                                                                        newDate != undefined ? newDate : null,
                                                                        true
                                                                    );
                                                                }}
                                                            />
                                                            <div className="additional-Vehicle_Details__error_message2" >
                                                                {errors.deliveryDate &&
                                                                    touched.deliveryDate &&
                                                                    errors.deliveryDate}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            : undefined}
                            <div>
                                <div className='row'>
                                    <Overlay
                                        show={errors.registrationInformationSelection && touched.registrationInformationSelection}
                                        target={registerDetailsSelectionShowErrorRef.current}
                                        placement="right"

                                    >
                                        <Popover id="popOverInformationSelection" className="additional-Vehicle_Details__error_message" style={{ 'marginLeft': '-28em', }}>
                                            <RawIntlProvider value={intl}>
                                                <FormattedMessage {...messages.dealer_draft_reg_details_error_label} />
                                            </RawIntlProvider>
                                        </Popover>
                                    </Overlay>
                                    <div className="col-md-12 additional-Vehicle_Details__description">
                                        <div className="col-md-6 additional-Vehicle_Details__label" ref={registerDetailsSelectionShowErrorRef}>
                                            <FormattedMessage {...messages.dealer_draft_reg_details_select_label} />
                                        </div>
                                    </div>
                                    <div className="additional-Vehicle_Details_update__radio">
                                        <img
                                            onClick={() => { setFieldValue("registrationInformationSelection", 'I', true) }}
                                            src={values.registrationInformationSelection === "I"
                                                ? "/assets/VMS_checked.png"
                                                : "/assets/VMS_unchecked.png"}
                                        />
                                        {' '} <FormattedMessage {...messages.dealer_draft_initial_license_label} />

                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="additional-Vehicle_Details_update__radio">
                                        <img
                                            onClick={() => { setFieldValue("registrationInformationSelection", 'T', true) }}
                                            src={values.registrationInformationSelection === "T"
                                                ? "/assets/VMS_checked.png"
                                                : "/assets/VMS_unchecked.png"}
                                        />
                                        {' '} <FormattedMessage {...messages.dealer_draft_temp_label} />

                                    </div>
                                </div>
                                <div className='row'  ref={noRegisterDetailsSelectionShowErrorRef}>
                                        <Overlay
                                            show={errors.noRegisterDetailsError}
                                            target={noRegisterDetailsSelectionShowErrorRef.current}
                                            placement="right"

                                        >
                                            <Popover id="popOverNoSelection" className="additional-Vehicle_Details__error_message" style={{ 'marginLeft': isIE ? '-35em' : '-59em', 'marginTop': '-.5em', 'maxWidth': '55em' }}>
                                                <RawIntlProvider value={intl}>
                                                    <FormattedMessage {...messages.dealer_draft_no_selection_error_label} />
                                                </RawIntlProvider>
                                            </Popover>
                                        </Overlay>
                                        <div className="additional-Vehicle_Details_update__radio">
                                            <img
                                                onClick={() => { setFieldValue("registrationInformationSelection", 'N', true) }}
                                                src={values.registrationInformationSelection === "N"
                                                    ? "/assets/VMS_checked.png"
                                                    : "/assets/VMS_unchecked.png"}
                                            />
                                            {' '}  <FormattedMessage {...messages.dealer_draft_reg_no_selection_label} />

                                    </div>
                                </div>
                            </div>
                            {values.registrationInformationSelection === "I" ?
                                <div>
                                    <div className='row'>
                                        <div className="col-md-12 additional-Vehicle_Details__description">
                                            <div className="col-md-6 additional-Vehicle_Details__label">
                                                <FormattedMessage {...messages.dealer_draft_reg_details_label} />
                                            </div>
                                        </div>
                                        <div className="col-md-12 additional-Vehicle_Details__description">
                                            <div className="col-md-3 additional-Vehicle_Details__sub-label">
                                                <FormattedMessage {...messages.dealer_draft_license_plate_description} />
                                            </div>

                                            <div className={classNames('col-md-6', 'additional-Vehicle_Details__date_edit')}>
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        <div className='row'>
                                                            <div className='additional-Vehicle__license'>
                                                                <input type="text" maxLength={10}
                                                                    onKeyDown={helperFunctions.isLicense.bind(this)}
                                                                    className="additional-Vehicle_Details_date__date_picker-input"
                                                                    onChange={(e) => {
                                                                        setFieldValue(
                                                                            "licensePlate",
                                                                            e.target.value,
                                                                            true
                                                                        );
                                                                    }}
                                                                    value={values.licensePlate}
                                                                    id="licensePlate"
                                                                    error={errors.licensePlate}
                                                                />
                                                                <div className="additional-Vehicle_Details__error_message2" >
                                                                    {errors.licensePlate &&
                                                                        touched.licensePlate &&
                                                                        errors.licensePlate}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12 additional-Vehicle_Details__description">
                                            <div className="col-md-3 additional-Vehicle_Details__sub-label">
                                                <FormattedMessage {...messages.dealer_draft_registration_date_description} />
                                            </div>

                                            <div className={classNames('col-md-6', 'additional-Vehicle_Details__date_edit')}>
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        <div className='row'>
                                                            <Overlay
                                                                show={errors.licenseDateRange && touched.licenseDateRange}
                                                                target={licenseDateShowErrorRef.current}
                                                                placement="right"

                                                            >
                                                                <Popover id="popOverLicenseDate" className="additional-Vehicle_Details__error_message">
                                                                    <RawIntlProvider value={intl}>
                                                                        <FormattedMessage {...messages.dealer_draft_reg_date_invalid_error_label} />
                                                                    </RawIntlProvider>
                                                                </Popover>
                                                            </Overlay>
                                                            <div className='additional-Vehicle_Details__date_picker' ref={licenseDateShowErrorRef}>
                                                                <InputCalendar
                                                                id="licenseDate"
                                                                error={errors.licenseDate}
                                                                locale={userLocale}
                                                                modifiers={{disabled: {
                                                                    before: new Date(moment().add(1, "days")),
                                                                }}}
                                                                initialValue={values.licenseDate}
                                                                onDateChange={(newDate) => {
                                                                    setFieldValue(
                                                                        "licenseDate",
                                                                        newDate != undefined ? newDate : null,
                                                                        true
                                                                    );
                                                                }}
                                                                />
                                                                <div className="additional-Vehicle_Details__error_message2" >
                                                                    {errors.licenseDate &&
                                                                        touched.licenseDate &&
                                                                        errors.licenseDate}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12 additional-Vehicle_Details__description">
                                            <div className="col-md-3 additional-Vehicle_Details__sub-label">
                                                <FormattedMessage {...messages.dealer_draft_Registration_state_description} />
                                            </div>

                                            <div className={classNames('col-md-6', 'additional-Vehicle_Details__date_edit')}>
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        <div className='row'>
                                                            <div>
                                                                <select
                                                                id="licenseState"
                                                                error={errors.licenseState}
                                                                className='additional-Vehicle_Details_date__date_picker-input'
                                                                onChange={(e) => {
                                                                    setFieldValue(
                                                                        "licenseState",
                                                                        e.target.value,
                                                                        true
                                                                    );
                                                                }}  >
                                                                {values.licenseState != '' ? <option key="select_state1" value="" default>{values.licenseState}</option>
                                                                    : <option key="select_state" value="" default>Select State</option>}
                                                                {usStates.map((item) => {
                                                                    return <option key={item.get('abbreviation')}
                                                                        value={item.get('abbreviation')}>{item.get('abbreviation')}</option>
                                                                })

                                                                }

                                                                </select>
                                                            </div>
                                                            <div className="additional-Vehicle_Details__error_message2" >
                                                                {errors.licenseState &&
                                                                    touched.licenseState &&
                                                                    errors.licenseState}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : undefined}

                            {values.registrationInformationSelection === "T" ?
                                <div>
                                    <div className='row'>
                                        <div className="col-md-12 additional-Vehicle_Details__description">
                                            <div className="col-md-6 additional-Vehicle_Details__label">
                                                <FormattedMessage {...messages.dealer_draft_reg_details_label} />
                                            </div>
                                        </div>
                                        <div className="col-md-12 additional-Vehicle_Details__description">
                                            <div className="col-md-3 additional-Vehicle_Details__sub-label">
                                                <FormattedMessage {...messages.dealer_draft_temp_license_label} />
                                            </div>

                                            <div className={classNames('col-md-6', 'additional-Vehicle_Details__date_edit')}>
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        <div className='row'>
                                                            <div className='additional-Vehicle__license'>
                                                                {requestStatus === "VIEW" ? <div className="additional-Vehicle_Details_date__date_picker-input">{tempLicensePlate}</div> :
                                                                    <input type="text" maxLength={10}
                                                                        onKeyDown={helperFunctions.isLicense.bind(this)}
                                                                        className="additional-Vehicle_Details_date__date_picker-input"
                                                                        onChange={(e) => {
                                                                            setFieldValue(
                                                                                "tempPlate",
                                                                                e.target.value,
                                                                                true
                                                                            );
                                                                        }}
                                                                        value={values.tempPlate}
                                                                        id="tempPlate"
                                                                        error={errors.tempPlate}

                                                                    />
                                                                }
                                                                <div className="additional-Vehicle_Details__error_message2" >
                                                                    {errors.tempPlate &&
                                                                        touched.tempPlate &&
                                                                        errors.tempPlate}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12 additional-Vehicle_Details__description">
                                            <div className="col-md-3 additional-Vehicle_Details__sub-label">
                                                <FormattedMessage {...messages.dealer_draft_temp_exp_label} />
                                            </div>

                                            <div className={classNames('col-md-6', 'additional-Vehicle_Details__date_edit')}>
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        <div className='row'>
                                                            <Overlay
                                                                show={errors.tempDateRange && touched.tempDateRange}
                                                                target={tempDateShowErrorRef.current}
                                                                placement="right"

                                                            >
                                                                <Popover id="popOverTempDate" className="additional-Vehicle_Details__error_message">
                                                                    <RawIntlProvider value={intl}>
                                                                        <FormattedMessage {...messages.dealer_draft_reg_date_invalid_error_label} />
                                                                    </RawIntlProvider>
                                                                </Popover>
                                                            </Overlay>
                                                            <div className='additional-Vehicle_Details__date_picker' ref={tempDateShowErrorRef}>
                                                                <InputCalendar 
                                                                id="tempDate"
                                                                error={errors.tempDate}
                                                                locale={userLocale}
                                                                initialValue={values.tempDate}
                                                                modifiers={{disabled: {
                                                                    before: new Date(moment().add(1, "days")),
                                                                }}}
                                                                onDateChange={(newDate) => {
                                                                    setFieldValue(
                                                                        "tempDate",
                                                                        newDate != undefined ? newDate : null,
                                                                        true
                                                                    );
                                                                }}
                                                                />
                                                                <div className="additional-Vehicle_Details__error_message2" >
                                                                    {errors.tempDate &&
                                                                        touched.tempDate &&
                                                                        errors.tempDate}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12 additional-Vehicle_Details__description">
                                            <div className="col-md-3 additional-Vehicle_Details__sub-label">
                                                <FormattedMessage {...messages.dealer_draft_temp_state_label} />
                                            </div>

                                            <div className={classNames('col-md-6', 'additional-Vehicle_Details__date_edit')}>
                                                <div className='row'>
                                                    <div className="col-md-12">
                                                        <div className='row'>
                                                            <div>
                                                                <select
                                                                id="tempState"
                                                                error={errors.tempState}
                                                                className='additional-Vehicle_Details_date__date_picker-input'
                                                                onChange={(e) => {
                                                                    setFieldValue(
                                                                        "tempState",
                                                                        e.target.value,
                                                                        true
                                                                    );
                                                                }}>
                                                                {values.tempState != '' ? <option key="select_state1" value="" default>{values.tempState}</option>
                                                                    : <option key="select_state" value="" default>Select State</option>}
                                                                {usStates.map((item) => {
                                                                    return <option key={item.get('abbreviation')}
                                                                        value={item.get('abbreviation')}>{item.get('abbreviation')}</option>
                                                                })

                                                                }
                                                                </select>
                                                            </div>
                                                            <div className="additional-Vehicle_Details__error_message2" >
                                                                {errors.tempState &&
                                                                    touched.tempState &&
                                                                    errors.tempState}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                : undefined}
                        </div>
                        <div>
                            <hr className="request_approval__hr" />


                            <div className='row'>
                                <div className="request_approval__pop-label">
                                    <Overlay
                                        show={errors.paymentAccepted && touched.paymentAccepted}
                                        target={paymentInformationAcceptedShowErrorRef.current}
                                        placement="right"

                                    >
                                        <Popover id="popOverPaymentAccepted" className="request_approval__error_message" style={{ 'marginLeft': '-7em', 'marginTop': '.5em', 'maxWidth': '35em' }}>
                                            <RawIntlProvider value={intl}>
                                                <FormattedMessage {...messages.dealer_draft_payment_accepted_error} />
                                            </RawIntlProvider>
                                        </Popover>
                                    </Overlay>
                                    <div className="col-lg-8 request_approval__restore" ref={paymentInformationAcceptedShowErrorRef}>
                                        <img onClick={() => { setFieldValue("paymentAccepted", 'P', true) }}
                                            src={values.paymentAccepted === 'P'
                                                ? "/assets/VMS_checked.png"
                                                : "/assets/VMS_unchecked.png"}
                                        />
                                        {' '} <FormattedMessage
                                            values={{ checkingAccount: vendorCheckingAccount }} {...messages.dealer_draft_confirm_payment} />

                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <div className="col-lg-6 request_approval__restore"
                                    role="button"
                                    onClick={onDeleteResetClick}>
                                    <img src="/assets/VMS_28button_edit_clear.png" />
                                    {' '}
                                    <FormattedMessage {...messages.restore_request} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 request_approval__return"
                                    role="button"
                                    onClick={onReturnClickHandler}>
                                    <img src="/assets/VMS_33button_back_blue.png" />
                                    {' '}
                                    <FormattedMessage {...messages.return} />
                                </div>

                                <div className={classNames(
                                    { 'col-md-6 request_approval__payment': !isSubmitting },
                                    { 'col-md-6 request_approval__payment-disabled': isSubmitting })}>
                                    <a className="request_approval__btn" onClick={() => { handleSubmit(); }}>
                                        <FormattedMessage {...messages.request_payment} />
                                        <IntlProvider locale="en">
                                            <FormattedNumber value={subTotal} style="currency"
                                                currency={selectedCurrency} />
                                        </IntlProvider>
                                        {' '}<img src="/assets/VMS_33button_go_bblue.png" />
                                    </a>
                                    <div className="request_approval-spinner inline-block">
                                        {isSubmitting ?
                                            <Spinner spinnerType="dark-blue" />
                                            : undefined
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </form>
                );
            }}
        </Formik>
    </div>

    // #endregion
}



// #endregion
export default injectIntl(AdditionalVehicleDetails);
